module.exports = __webpack_public_path__ + "static/media/Niveau_elN10_3_713065.fb8895a6.png";